import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { transactions } from './type';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

interface TransactionDetailsProps {
  title: string;
}
const TransactionDetail: React.FC<TransactionDetailsProps> = ({ title }) => {
  useDocumentTitle(title);
  const { id } = useParams<{ id: string }>();
  const transaction = transactions.find((t) => t.id === parseInt(id ?? ""));

  if (!transaction) {
    return <p>Transaction not found.</p>;
  }

  return (
    <div className="container my-4">
      <Link to="../" className="btn btn-secondary mb-3">Back to Transactions</Link>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">{transaction.type}</h5>
          <h6 className="card-subtitle mb-2 text-muted">{transaction.date}</h6>
          <p className="card-text">
            <strong>Description:</strong> {transaction.description}
          </p>
          <p className="card-text">
            <strong>Amount:</strong> {transaction.amount}
          </p>
          <p className="card-text">
            <strong>Status:</strong> {transaction.status}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetail;
